export const E2E_GREEN_TIP = 'e2e_feature_gate';

export const FEATURE_GATES_LIST = [
	E2E_GREEN_TIP
];
